<script lang="ts">
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import { Alert, Button, Icon } from "sveltestrap";
    import IconChevron from "../Components/Shared/IconChevron.svelte";
    import View from "../Components/Shared/View.svelte";
    import type { UserDto } from "../global";
    import { currentUser } from "../Services/user";
    import { gamePoints } from "../Services/game"
    import { getPicturesByLabels } from "../Services/pictures";
    import { sendEmail } from "../Services/email";
    import md5 from "md5";


    let user: UserDto;
    let photosNum: number = 0;
    let isGameEnd: boolean = false;
    let minutesGame: number = 0;
    let userEmail: string = null;
    let showSendEmailOk: boolean = false;
    let sendEmailError: boolean = false;

    onMount(async () => {

        user = await currentUser.toJSON();
    
        const gameEndDate = localStorage.getItem('game_end_date');
        const gameStartDate = localStorage.getItem('game_start_date');

        const photos = await getPicturesByLabels([md5(currentUser.value.email)]);

        photosNum = photos.length;   

        if (user && gameEndDate) {

            const inicio = new Date(gameStartDate).getTime();
            const fin = new Date(gameEndDate).getTime();
            
            const diff = (fin - inicio);

            minutesGame = Math.round(diff/(1000*60*60));

            if(user.email) userEmail = currentUser.value.email;

            isGameEnd = true;

        }


    })

    async function sendToEmail(){
        
        if (!userEmail) {
            return;
        }

        await sendEmail(userEmail, user.name, null).catch(() => {
            sendEmailError = true;
        });

        showSendEmailOk = true;
    }

</script>

<style lang="scss">


    .content-info{
        position: relative;
        // flex: 1 1 0;
        text-align: center;
        background-color:#fff;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        width: 75%;
        align-self: center;
    }

    .activity-end {
        position: fixed;
        z-index: 50;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        touch-action: auto;
        pointer-events: auto;
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .header {
        height: 60px;
        display: flex;
        border-bottom: 2px solid grey;
    }

    .close-btn {
        width: 60px;
        height: 60px;
        border: none;
        background-color: transparent;
    }

    .title {
        width: calc(100% - 120px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        font-size: 1.2rem;
    }

    .content {
        flex: 1 1 0;
        overflow: auto;

        &.flex {
            display: flex;
            flex-direction: column;
        }
    }

    .icon-people{
        margin: 20px;
    }

    .text-cong{
        font-size: 18px;
    }

    .resumen-game{
        padding: 10px 40px 10px 20px;
        width: 100%;
        background-color: #F7F7F7;
        border-radius: 10px;

        .info-card{
            text-align: start;
            width: 75%;
            margin: auto;
            font-weight: bold;
        }

        :global(.icon-info){
            background-color: #B3B3B3;
            color: white;
            padding: 6px 8px;
            font-size: 20px;
            border-radius: 5px;
            margin-right: 10px;
        }
    }

    .info-email{
        margin-top: 15px;
        text-align: center;

        :global(Button){
            width: 100%;
            background-color: var(--color-primary) !important;
            height: 45px;
            font-size: 20px;
            font-weight: 300;
            border-radius: 10px !important;
            margin-bottom: 15px;
        }

        input{
            text-align:center;
            display: block;
            width: 100%;
            height: 45px;
            border-radius: 10px;
            margin-bottom: 15px;
            border-color: #E4E4E4 !important;
        }
    }

    .share-buttons{
        margin-bottom: 10px;
        width: 100%;
        display: block;

        :global(.share-button){
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }

</style>



<View flex>

    <div class="activity-end" >
        <div class="header">
            <button type="button" class="close-btn" >
                <IconChevron />
            </button>
            <div class="title">Fin del juego</div>
        </div>
        <div class="content-info">
            
            <div class="icon-people">
                <img src="/images/people-end.png" alt="">
            </div>

            <div class="text-cong">
                {#if user}
                    <p><strong>¡Felicidades {currentUser.value.name}, has completado la misión!</strong></p>
                {/if}
               
            </div>

            <div class="resumen-game">
                <p>Tus números:</p>

                <div class="info-card">
                    <p><Icon class="icon-info" name="clock-history"/> {minutesGame} minutos</p>

                    <p><Icon class="icon-info" name="server"/> {$gamePoints} puntos</p>
    
                    <p><Icon class="icon-info" name="camera-fill"/> {photosNum} fotos subidas</p>
                </div>
       

            </div>

            <div class="info-email">

                {#if !showSendEmailOk}   
                    <p><strong>Te enviaremos tu premio a tu email:</strong></p>

                    <input type="email" bind:value={userEmail} placeholder="Escribe tu email">

                    <Button type="button" on:click={sendToEmail}> Enviar </Button>
                {:else}

                    <p><strong>Su email ha sido enviado</strong></p>

                {/if}

                {#if sendEmailError}
                    <Alert color="warning" > Ha ocurrido un error al enviar el email, vuelva a intentarlo </Alert>
                {/if}

                <Button type="button" on:click={() => navigate('/')}> Volver a Jugar </Button>
      
            </div>
        </div>
    </div>


</View>



